import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { cn } from '@/utils';

type SwitchProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
  className?: string;
  onChange?: (checked: boolean) => void;
  value?: boolean;
};

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>(
  ({ className, onChange, value, checked, ...props }, ref) => (
    <SwitchPrimitives.Root
      className={cn(
        'focus-visible:ring-ring focus-visible:ring-offset-background peer inline-flex h-[22px] w-[31px] shrink-0 cursor-pointer items-center rounded-[52.78px] border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[#039BE5] data-[state=unchecked]:bg-gray-300',
        className,
      )}
      {...props}
      checked={checked ?? value}
      onCheckedChange={(event) => {
        // @ts-ignore
        if (onChange) onChange(event);
        // @ts-ignore
        if (props.onCheckedChange) props.onCheckedChange(event);
      }}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          'pointer-events-none block h-[16.58px] w-[16.58px] rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-2.5 data-[state=unchecked]:translate-x-0',
        )}
      />
    </SwitchPrimitives.Root>
  ),
);

Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
